import { useEffect } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

type Reset = (data?: any, options?: { keepValues?: boolean; keepDirty?: boolean; keepDefaultValues?: boolean }) => void;

type Trigger<
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = (
  name?: TFieldName | TFieldName[],
  options?: {
    shouldFocus?: boolean;
  }
) => Promise<boolean>;

export const useResetDirtyFields = (isTouched: boolean, requestAPIData: any, reset: Reset, trigger: Trigger) => {
  useEffect(() => {
    reset(undefined, { keepValues: true, keepDirty: false, keepDefaultValues: false });
    isTouched && trigger();
  }, [requestAPIData, isTouched, reset, trigger]);
};
export default useResetDirtyFields;
